// extracted by mini-css-extract-plugin
export default {"locking":"Dunning_View_locking__+Yy8p","info":"Dunning_View_info__3Cj8O","action_1":"Dunning_View_action_1__G2Nl5","action_2":"Dunning_View_action_2__Ia-Jb"};